import Spinner from 'components/spinner/spinner.component';
import StatsigWrapper from 'components/statsig/statsig-wrapper.component';
import { Helmet } from 'react-helmet';
import Theme from 'Theme';

const SpreedlyPaymentHostedWrapper = ({ children, isLoading }) => {
  return (
    <StatsigWrapper>
      <Helmet>
        <meta
          name="viewport"
          content="width=device-width, user-scalable=no, initial-scale=1, maximum-scale=1"
        />
      </Helmet>
      <Theme>{isLoading ? <Spinner /> : children}</Theme>
    </StatsigWrapper>
  );
};

export default SpreedlyPaymentHostedWrapper;
